import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import config from '../../config';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    load: 'languageOnly',
    fallbackLng: 'en',
    supportedLngs: (config.i18n.languages as unknown) as string[],
    // debug: true,

    interpolation: {
      escapeValue: false,
    },

    backend: {
      loadPath: '/assets/i18n/{{lng}}.json',
    },

    detection: {
      order: ['querystring', 'localStorage', 'cookie', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
  });

/**
 * Get the current (detected) language based on the supported languages.
 *
 * @example
 *  getCurrentLanguage() => 'de'
 *  getCurrentLanguage() => 'en'
 */
export const getCurrentLanguage = (): string => {
  const lang = i18n.language?.split('-')[0];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return config.i18n.languages.includes(lang as any) ? lang : 'en';
};

export default i18n;
